module.exports = __webpack_public_path__ + "static/media/icn-healthplan-v2.33d5f08d.svg";